export const appName = "ГИС «Платформа «ЦХЭД»";
export const defaultFilterPlaceholder = "Не задан";
